import Vue from 'vue';
import Router from 'vue-router';
import store from '@/plugins/store';
import options from '@/router.config';

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(Router);
}

const router = new Router(options);

router.beforeEach(async (to, from, next) => {
  await store.dispatch('loadAgent');

  if (!to.meta.public && !store.state.isAuthorized) {
    next({ name: 'pagenotfound' });
  }

  if (to.meta.hideDashboard) {
    store.dispatch('hideDashboard');
  } else {
    store.dispatch('showDashboard');
  }

  next();
});

export default router;
